import { Caching } from './Caching';

export class Handler extends Caching
{
	public handle(reqObj)
	{
		if (reqObj.getL2() == "Update") {
			return this.cacheUpdate(reqObj);
		} else if (reqObj.getL2() == "Delete") {
			return this.cacheDelete(reqObj);
		}
		this.routeInvalid(reqObj);
	}
}